import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { Observable, filter } from "rxjs";
import { LoadingService } from "./core/services/loading.service";
import { NavigationEnd, Router } from "@angular/router";
import { SecretariaService } from './core/services/secretaria.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: false
})
export class AppComponent implements OnInit, AfterContentChecked {
  loading$: Observable<boolean>;
  showHelp = true;

  constructor(
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public secretaria: SecretariaService
  ) {}

  ngOnInit(): void {
    this.loading$ = this.loadingService.loading$;

    // Controla a visibilidade do botão/agent de ajuda conforme a rota atual
    const updateVisibility = (url: string) => {
      const lower = (url || '').toLowerCase();
      // Ocultar em login e páginas de registro/cadastro
      const hide = lower === '/login'
        || lower.startsWith('/login?')
        || lower.includes('/auth/login')
        || lower === '/auth' || lower.startsWith('/auth?') || lower.endsWith('/auth')
        || lower.includes('/auth/')
        || lower.includes('registro')
        || lower.includes('registr')
        || lower.includes('cadastro');
      this.showHelp = !hide;
    };

    // Atualiza imediatamente com a URL atual
    updateVisibility(this.router.url);

    // Atualiza a cada navegação concluída
    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => updateVisibility(e.urlAfterRedirects || e.url));
  }

  ngAfterContentChecked(): void {
    // Prevent ExpressionChangedAfterItHasBeenCheckedError
    this.cdr.detectChanges();
  }
}
